import { useMemo } from "react";
import classnames from "classnames";
import { User } from "~/context/userContext";
import { Analytics } from "~/components/GoogleAnalytics";
import { Image } from "~/components/Image";
import css from "./index.module.scss";

const getAlt = (media: string) => `Share this event on ${media}`;

type ShareProps = {
  user: User | null;
  url: string;
  text: string;
  noMargin?: boolean;
  className?: string;
  size?: number;
};

export const Share = ({ user, url, text, noMargin, className, size = 44 }: ShareProps): JSX.Element => {
  let label: string;
  if (url.includes("archives")) {
    label = `Archive: ${text}`;
  } else if (url.includes("classrooms")) {
    label = `Classroom: ${text}`;
  }

  const style = useMemo(
    () => ({
      width: size,
      height: size,
      display: "inline-block",
    }),
    [size]
  );

  return (
    <div
      className={classnames([
        css.share,
        className,
        {
          [css.noMargin]: noMargin,
        },
      ])}
    >
      <div>
        <a
          target="_blank"
          href={`https://twitter.com/intent/tweet?url=${url}&hashtags=NowDo&text=${text}`}
          className={css.twitter}
          onClick={() =>
            Analytics({
              action: "click_twitter_share",
              label,
              user,
            })
          }
          rel="noreferrer"
          style={style}
        >
          <Image src="/images/share__twitter.svg" width={size} height={size} alt={getAlt("twitter")} />
        </a>
        <a
          target="_blank"
          href={`http://line.me/R/msg/text/?${url}`}
          className={css.line}
          onClick={() =>
            Analytics({
              action: "click_line_share",
              label,
              user,
            })
          }
          rel="noreferrer"
          style={style}
        >
          <Image src="/images/share__line.svg" width={size} height={size} alt={getAlt("line")} />
        </a>
        <a
          target="_blank"
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          className={css.facebook}
          onClick={() =>
            Analytics({
              action: "click_facebook_share",
              label,
              user,
            })
          }
          rel="noreferrer"
          style={style}
        >
          <Image src="/images/share__facebook.svg" width={size} height={size} alt={getAlt("facebook")} />
        </a>
      </div>
    </div>
  );
};
